export const ANDROID_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.adultswim.videoapp.android';
export const APP_BASE_DEEP_LINK = 'adultswim://deeplink';
export const IOS_STORE_LINK = 'https://itunes.apple.com/app/adult-swim/id417871100?mt=8';



// WEBPACK FOOTER //
// ./src/common/constants/mobile.js